import React from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

class FinancialOutlierModal extends React.Component {
  getSeverityColor = (severity) => {
    switch (severity) {
      case 'high': return '#ff3b8e';
      case 'medium': return '#eba93e';
      case 'low': return '#215BFF';
      default: return '#666';
    }
  };

  getSeverityLabel = (severity) => {
    switch (severity) {
      case 'high': return 'High Priority';
      case 'medium': return 'Medium Priority';
      case 'low': return 'Low Priority';
      default: return '';
    }
  };

  getTypeLabel = (type) => {
    switch (type) {
      case 'small_order': return '💰 Unusually Small Order';
      case 'late_order': return '⏰ Late Order';
      case 'late_recurring': return '🔄 Late Recurring Payment';
      default: return '';
    }
  };

  render() {
    const { isOpen, onClose, outlierData } = this.props;
    
    if (!outlierData || !outlierData.hasOutliers) {
      return null;
    }

    const { outliers, summary, monthComparison } = outlierData;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        shouldCloseOnOverlayClick={true}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          },
          content: {
            position: 'relative',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            maxWidth: '700px',
            width: '90%',
            maxHeight: '85vh',
            margin: '0',
            padding: '0',
            border: 'none',
            borderRadius: '12px',
            background: '#fff',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            inset: 'auto'
          }
        }}
      >
        <div style={{ 
          padding: '20px 24px',
          borderBottom: '1px solid #eee',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{ color: '#3B4EFF', display: 'flex', alignItems: 'center', gap: '10px', margin: 0, fontSize: '20px' }}>
            Smart Financial Alerts
          </h2>
          <button 
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '28px',
              cursor: 'pointer',
              color: '#999',
              padding: '0',
              lineHeight: '1',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              transition: 'background 0.2s'
            }}
            onMouseOver={(e) => e.target.style.background = '#f0f0f0'}
            onMouseOut={(e) => e.target.style.background = 'none'}
          >×</button>
        </div>

        <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '24px' }}>
          <div style={{
            background: '#f8f9fa',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px'
          }}>
            <div>
              <strong>{summary.total}</strong> outlier{summary.total !== 1 ? 's' : ''} detected
            </div>
          </div>

          <div>
            <h3 style={{ fontSize: '16px', color: '#333', marginBottom: '15px' }}>
              Alerts ({outliers.length})
            </h3>
            {outliers.map((outlier, index) => (
              <div
                key={index}
                style={{
                  border: `2px solid ${this.getSeverityColor(outlier.severity)}`,
                  borderRadius: '8px',
                  padding: '12px',
                  marginBottom: '12px',
                  background: '#fff'
                }}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginBottom: '8px'
                }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ 
                      fontWeight: 'bold',
                      color: '#333',
                      marginBottom: '4px'
                    }}>
                      {this.getTypeLabel(outlier.type)}
                    </div>
                    <div style={{ fontSize: '14px', color: '#666' }}>
                      {outlier.message}
                    </div>
                  </div>
                  {outlier.severity && (
                    <div style={{
                      background: this.getSeverityColor(outlier.severity),
                      color: '#fff',
                      padding: '4px 10px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      whiteSpace: 'nowrap',
                      marginLeft: '10px'
                    }}>
                      {this.getSeverityLabel(outlier.severity)}
                    </div>
                  )}
                </div>

                {outlier.purchaser && (
                  <div style={{ fontSize: '13px', color: '#888', marginTop: '4px' }}>
                    Customer: {outlier.purchaser}
                  </div>
                )}
              </div>
            ))}
          </div>

          {monthComparison && (
            <div style={{
              background: '#e3f2fd',
              padding: '12px 16px',
              borderRadius: '8px',
              marginTop: '20px'
            }}>
              <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#333', marginBottom: '8px' }}>
                📊 Month-over-Month Comparison
              </div>
              <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.6' }}>
                <div>
                  <strong>Revenue:</strong> {monthComparison.changes.revenue >= 0 ? '↑' : '↓'} {Math.abs(monthComparison.changes.revenue).toFixed(1)}% 
                  ({monthComparison.changes.revenue >= 0 ? 'increase' : 'decrease'})
                </div>
                <div>
                  <strong>Orders:</strong> {monthComparison.changes.orders >= 0 ? '↑' : '↓'} {Math.abs(monthComparison.changes.orders).toFixed(1)}% 
                  ({monthComparison.changes.orders >= 0 ? 'increase' : 'decrease'})
                </div>
              </div>
            </div>
          )}
        </div>

        <div style={{ padding: '16px 24px', borderTop: '1px solid #eee', background: '#f8f9fa' }}>
          <div style={{ textAlign: 'right' }}>
            <button
              onClick={onClose}
              style={{
                padding: '12px 24px',
                background: '#3B4EFF',
                color: '#fff',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '14px',
                transition: 'background 0.2s'
              }}
              onMouseOver={(e) => e.target.style.background = '#2a3acc'}
              onMouseOut={(e) => e.target.style.background = '#3B4EFF'}
            >
              Got it, I'll review these
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default FinancialOutlierModal;

